import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScoutAiTriggerService {
    private _openRequested = signal(0);
    openRequested = this._openRequested.asReadonly();

    requestOpen(): void {
        this._openRequested.update(n => n + 1);
    }
}
